/**
 * About Us entrance: text and media slide in from opposite sides as the
 * section scrolls into view, using revealOnScroll's x-offset option so the
 * two halves read as converging toward the center rather than both rising
 * from the same direction.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('[data-flv-about-text]', { x: -40, y: 0, scale: 1, duration: 0.9 });
revealOnScroll('[data-flv-about-media]', { x: 40, y: 0, scale: 1, duration: 0.9, delay: 0.1 });
